/**
 * @callback GetAppVersionCallback
 * @returns {string | Promise<string>}
 */

/**
 * @typedef ClientHeadersInterceptorCreatorParams
 * @type {object}
 * @property {string} [clientId]
 * @property {GetAppVersionCallback} [getAppVersion]
 */

/**
 * @param {ClientHeadersInterceptorCreatorParams} param0
 */
export function createClientHeadersInterceptor({ clientId, getAppVersion }) {
  /**
   * @param {import('axios').AxiosRequestConfig} axiosRequestConfig
   */
  async function interceptor(axiosRequestConfig) {
    const appVersion = await getAppVersion();

    return {
      ...axiosRequestConfig,
      headers: {
        ...axiosRequestConfig.headers,
        'x-client-id': clientId,
        'x-client-version': appVersion,
      },
    };
  }

  return interceptor;
}
